
import { apiCall } from "./Interceptor";

const GET_PROFILE_DETAILS = "/company/get";

const getProfileDetailsById = async (id) => {
    const response = await apiCall.get(`${GET_PROFILE_DETAILS}?id=${id}`);
    return response;
}

export default {
    getProfileDetailsById,
};
